import('./bootstrap').catch(() => {});
